import AppLayout from "components/Layout/AppLayout";
import React, { useEffect, useState } from "react";
import OrganiseList from "./components/OrganiseList";
import ExternalProperties from "./components/ExternalProperties";
import BookmarkedProperties from "./components/BookmarkedProperties";
import OrganizeInfoSection from "./components/OrganizeInfoSection";
import OrganizerNotSubscribed from "./components/OrganizerNotSubscribed";
import NotSubscribed from "../../components/Subscribe/NotSubscribed";
import CustomListDialog from "components/Dialog/CustomListDialog";
import { useOrganiseList } from "context/OrganiseListContext";
import useAuth from "hooks/useAuth";
import DoubtAndDiscardedPropertiesPopup from "./components/DoubtAndDiscardedPropertiesPopup";
import useSubscriptionLogic from "hooks/useSubscriptionLogic";
import { convertHexToRGBA, isObjectEmpty } from "utils/commonUtils";
import { useLocation } from "react-router";

const Organizer = () => {
  const {
    user,
    authLoading,
    showNotSubscribed,
    isOpenListDialog,
    setIsOpenListDialog,
    handleOrganiseListAdd,
  } = useSubscriptionLogic();
  const { selectedOrganiseList } = useOrganiseList();

  const location = useLocation();

  // Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <AppLayout>
      <div
        style={{
          backgroundColor: isObjectEmpty(selectedOrganiseList)
            ? "#F5F5F5"
            : convertHexToRGBA(selectedOrganiseList.color, 0.2),
        }}
        className={`h-auto relative min-h-[calc(100vh-88px)] pt-[29px] lg:pt-[41px] pb-[100px] lg:pb-[41px] w-full px-5 lg:px-[48px] grid gap-y-[32px]`}
      >
        {user ? (
          // showNotSubscribed ? (
          //   <NotSubscribed setIsOpenListDialog={setIsOpenListDialog} />
          // ) : (
          <>
            <OrganiseList setIsOpenListDialog={setIsOpenListDialog} />
            <OrganizeInfoSection />
            <ExternalProperties />
            <BookmarkedProperties />
            <DoubtAndDiscardedPropertiesPopup />
          </>
        ) : (
          // )
          !authLoading && (
            <NotSubscribed setIsOpenListDialog={setIsOpenListDialog} />
          )
        )}
      </div>

      <CustomListDialog
        isOpen={isOpenListDialog}
        onClose={() => setIsOpenListDialog(false)}
        onAdd={handleOrganiseListAdd}
      />
    </AppLayout>
  );
};

export default Organizer;
